// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  token: sessionStorage.getItem('BearerToken') || '',
  user: {},
}
